const EMPTY_OPTIONS = Object.freeze({});

export const DEFAULT_API_OPTIONS = EMPTY_OPTIONS;
export const DEFAULT_CLIENT_OPTIONS = EMPTY_OPTIONS;
